import _ from "lodash";
import { DECIMAL_POINTER, formatNumber, formatNumberStr, formatStrForEditable, formatStrToNumber, validateNumberStr, validateNumberStrWithLength, validatePercentageStr } from "presentation/utils/numberUtil";
import { memo, useEffect, useState } from "react";
import { CommonField, FieldType, InputField } from "veronica-ui-component/dist/component/core";

interface NumberInputProps {
    value: string | number;
    decimalPlaces?: number;
    disabled?: boolean,
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, fieldName: string, newValue: any) => void;
    width?: string,
    label?: string,
    errorMessage?: string,
    fieldName?: string,
    optional?: boolean,
    maxLength?: number,
    allowNegative?: boolean,
    required?: boolean;
    isPercentage?: boolean;
    maxRange?: number;
}

const NumberInputComponent: React.FC<NumberInputProps> = (props) => {
    const [inputValue, setInputValue] = useState<string | undefined | null>();
    const [inputByUser, setInputByUser] = useState<boolean>(false);
    const [inputChinese, setInputChinese] = useState<boolean>(false);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (inputChinese) {
            setInputValue(event.target.value);
            return;
        }
        if (!!!event.target.value) {
            setInputValue('');
            if (props.onChange && props.fieldName) {
                props.onChange(event, props.fieldName, null);
            }
            return;
        };

        setInputByUser(true);

        // const newValue = formatNumberStr(event.target.value, props.decimalPlaces??0, false, true);
        let newValue = event.target.value;
        if (props.isPercentage) {
            if (!validatePercentageStr(newValue, props.decimalPlaces ?? 0, props.allowNegative)) return;
        } else {
            // if (!validateNumberStr(newValue, props.decimalPlaces ?? 0, props.allowNegative)) return;
            if (props.maxLength) {
                if (!validateNumberStrWithLength(props.maxLength, newValue, props.decimalPlaces ?? 0, props.allowNegative)) return;
            } else {
                if (!validateNumberStr(newValue, props.decimalPlaces ?? 0, props.allowNegative)) return;
            }
        }

        // issue 36319 added
        if (props?.maxRange && inputValue && formatStrToNumber(newValue) > props.maxRange) {
            newValue = inputValue;
        }

        setInputValue(newValue);
        const numberVal = formatStrToNumber(newValue);
        if (!!props.onChange && !!props.fieldName) {
            props.onChange(event, props.fieldName, numberVal);
        }
    };

    const handleFocus = () => {
        if (inputValue) {
            const newValue = formatStrForEditable(inputValue);;
            setInputValue(newValue?.toString());
        }
        setInputByUser(true);
    }

    const handleBlur = () => {
        if (inputValue) {
            const newValue = formatNumberStr(inputValue, props.decimalPlaces ?? 0, false, true);
            setInputValue(newValue);
        }
        setInputByUser(false);
    }
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const key = event.key;
        const isDecimalSeparatorKey = key === DECIMAL_POINTER;
        const isDigitKey = /^\d$/.test(key);
        const isChineseCharacter = key === "Process";

        if (!isDecimalSeparatorKey && !isDigitKey && isChineseCharacter) {
            setInputValue(inputValue);
        }
    };

    useEffect(() => {
        if (inputByUser) return;

        let convertVal = "";
        if (props.value !== null && props.value !== '') {

            if (_.isNumber(props.value)) {
                convertVal = formatNumber((props.value as unknown as number), props.decimalPlaces ?? 0);
                setInputValue(convertVal);
            } else {
                convertVal = formatNumberStr(props.value as string, props.decimalPlaces ?? 0, false, true);
                setInputValue(convertVal);
            }
        } else {
            setInputValue(convertVal);
        }
    }, [inputByUser, inputValue, props.decimalPlaces, props.value]);

    return <div>
        {(!props.disabled) ?
            <InputField
                label={props.label}
                type={'text'}
                value={inputValue ?? ""}
                maxLength={(props.maxLength ? props.maxLength : 50) + (props.allowNegative ? 1 : 0)}
                width={props.width ? props.width : "100%"}
                errorMessage={props.errorMessage}
                optional={props.optional ? props.optional : false}
                onChange={handleInputChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                inputMode={"decimal"}
                allowNegative={props.allowNegative ?? false}
                onCompositionStart={() => {
                    setInputChinese(true);
                }}
                onCompositionEnd={(e: any) => {
                    setInputChinese(false);
                    setInputValue(e.target.value.replace(/[^0-9,]/g, ''));
                }}
                allowedSpecialChars={'all'}
            /> :
            <CommonField
                isReadOnly={true}
                readOnlyValue={inputValue ?? ""}
                fieldLabel={props.label ? props.label : ''}
                fieldType={FieldType.TEXT}
                fieldKey={''}
                requiredFieldList={[]}
                onFieldChange={() => { }}
                allowedSpecialChars={['all']}
            />
        }
    </div>
};

export default memo(NumberInputComponent);